import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { RouterProvider } from "react-router/dom";
import { ApiError } from "@/api/client";
import { handleAccessError } from "@/auth/access";
import { GradientDefs } from "@/components/ui/GradientDefs";
import { createRouter } from "./routes";
import { ThemeProvider } from "./theme";
import { ToastProvider } from "./toast";

function makeClient() {
  const onAuthError = (error: unknown) => {
    handleAccessError(error);
  };
  return new QueryClient({
    queryCache: new QueryCache({ onError: onAuthError }),
    mutationCache: new MutationCache({ onError: onAuthError }),
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        retry: (count, error) =>
          !(error instanceof ApiError && error.status >= 400 && error.status < 500) && count < 2,
      },
    },
  });
}

export function App() {
  const [client] = useState(makeClient);
  const [router] = useState(createRouter);
  return (
    <QueryClientProvider client={client}>
      <ThemeProvider>
        <ToastProvider>
          <GradientDefs />
          <RouterProvider router={router} />
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
